import { Article } from '../types/blog';

export const articles: Article[] = [
  {
    id: 'verification-statut-etudiant',
    title: "Nouveau système de vérification du statut étudiant",
    excerpt: "Guide détaillé des étapes à suivre pour faire vérifier votre statut étudiant et accéder à nos services.",
    content: `# Nouveau Système de Vérification du Statut Étudiant

Nous avons mis en place un nouveau système de vérification destiné aux étudiants souhaitant bénéficier de nos services. Cet article détaille les étapes à suivre pour être en conformité avec nos conditions générales d'utilisation.

## Étape 1 — Conformité des documents

Avant de soumettre vos justificatifs, assurez-vous de :

> Vérifier que l'année scolaire en cours est clairement indiquée sur votre certificat de scolarité.
> Vous assurer que le nom et prénom figurant sur votre espace client correspondent exactement à ceux présents sur votre justificatif.
> Si vous avez moins de 15 ans, joindre une autorisation parentale à votre certificat de scolarité.

En suivant ces recommandations, vous maximisez vos chances d'acceptation et gagnez du temps.

## Étape 2 — Soumission des documents

Une fois connecté(e) à votre espace client :

> 1. Cliquez sur votre nom et prénom, situés en haut à droite de l'écran.
![Description de l'image](https://my.francestudent.org/images/kb/3_FFS_TUTO_VERIF_1.png)
> 2. Sélectionnez Mes informations pour accéder aux détails de votre compte.
> 3. Repérez le message d'avertissement en orange, puis cliquez sur le lien indiqué. Le système de vérification des documents apparaîtra alors dans une nouvelle fenêtre.

Vous n'aurez plus qu'à soumettre vos documents, confirmer l'envoi et attendre que nous procédions aux démarches nécessaires.

## Vérification du statut

Pour savoir si vous avez été vérifié(e), retournez sur la même page. Celle-ci se mettra automatiquement à jour une fois la vérification complétée.

Besoin d'aide ? Notre support reste à votre disposition. La communauté est également présente sur Discord : [https://discord.gg/francestudent](https://discord.gg/francestudent).`,
    image: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&q=80",
    date: "18 Décembre 2024",
    readTime: "4 min",
    category: "Guide",
    author: {
      name: "#TeamFranceStudent",
      avatar: "https://i.imgur.com/dUtV8AP.png"
    }
  },
  {
    id: 'nouveautes-2024',
    title: "Les nouveautés de FRANCE STUDENT pour 2024",
    excerpt: "Découvrez toutes les nouvelles fonctionnalités et services disponibles pour les étudiants cette année.",
    content: `# Les nouveautés de FRANCE STUDENT pour 2024

Cette année marque un tournant majeur pour FRANCE STUDENT avec l'introduction de nombreuses améliorations et nouveaux services pour mieux répondre à vos besoins.

## Nouvelles Offres Étudiantes

Nous avons le plaisir de vous annoncer l'arrivée de nouvelles offres exclusives :

- **Canva Pro** : Accès premium gratuit pour tous les étudiants vérifiés
- **Suite Adobe** : Tarifs préférentiels sur l'ensemble de la Creative Cloud
- **Microsoft 365** : Licence complète incluse avec votre compte

## Amélioration des Services

Nous avons également amélioré nos services existants :

> 1. Interface utilisateur repensée pour plus de simplicité
> 2. Système de vérification optimisé
> 3. Support technique disponible 24/7

![Nouvelle interface](https://images.unsplash.com/photo-1531403009284-440f080d1e12?auto=format&fit=crop&q=80)

## Prochaines Évolutions

Voici un aperçu de ce qui vous attend dans les prochains mois :

- Application mobile dédiée
- Programme de parrainage
- Nouveaux partenariats exclusifs

Restez connectés pour ne rien manquer de nos actualités !

[Découvrir toutes les offres](https://my.francestudent.org/store)`,
    image: "https://images.unsplash.com/photo-1531403009284-440f080d1e12?auto=format&fit=crop&q=80",
    date: "18 Décembre 2024",
    readTime: "3 min",
    category: "Actualités",
    author: {
      name: "#TeamFranceStudent",
      avatar: "https://i.imgur.com/dUtV8AP.png"
    }
  }
];

export const getArticleById = (id: string): Article | undefined => {
  return articles.find(article => article.id === id);
};

export const getArticleNavigation = (currentId: string): { prev: Article | null; next: Article | null } => {
  const currentIndex = articles.findIndex(article => article.id === currentId);
  
  return {
    prev: currentIndex > 0 ? articles[currentIndex - 1] : null,
    next: currentIndex < articles.length - 1 ? articles[currentIndex + 1] : null
  };
};